import { useEffect, useState, useRef } from 'react';
import useOnClickOutside from 'hooks/useOnClickOutside';
import * as bodyLock from 'hooks/body-lock.js';

const HighlightBanner = () => {
  const [isActive, setIsActive] = useState(false);
  const [boxWidth, setBoxWidth] = useState(0);
  const [boxHeight, setBoxHeight] = useState(0);
  const [boxTop, setBoxTop] = useState(0);
  const [boxLeft, setBoxLeft] = useState(0);
  const [isActiveHighlight, setActiveHighlight] = useState(() => {
    if (window.innerWidth <= 767) {
      return '[data-banner-highlight-mobile]';
    } else if (window.innerWidth >= 768) {
      return '[data-banner-highlight]';
    }
  });
  const overlayRef = useRef(null);

  const showFeature = () => {
    if (window.innerWidth <= 767) {
      document
        .querySelector('.plan-compare-checkbox__sticky')
        .classList.add('is-active');
    }
    bodyLock.lock();

    setIsActive(!isActive);
  };

  useOnClickOutside(overlayRef, (e) => {
    if (e.target.closest('.highlight-banner__button') || !isActive) {
      return;
    }

    setIsActive(false);
    bodyLock.unlock();
  });

  useEffect(() => {
    function handleResize() {
      let ourTarget = '';

      if (window.innerWidth <= 767) {
        ourTarget = '[data-banner-highlight-mobile]';
      } else if (window.innerWidth >= 768) {
        ourTarget = '[data-banner-highlight]';
      }

      const trackedItem = document
        .querySelector(ourTarget)
        .getBoundingClientRect();

      setBoxWidth(trackedItem.width);
      setBoxHeight(trackedItem.height);
      setBoxTop(trackedItem.y);
      setBoxLeft(trackedItem.x);
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleResize);

    setTimeout(() => {
      handleResize();
    }, '200');

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleResize);
    };
  }, []);

  return (
    <>
      <div className="highlight-banner">
        <div className="highlight-banner__content">
          <div className="highlight-banner__copy">
            Want an easier way to see differences between plans?
          </div>
          <button
            className="highlight-banner__button"
            onClick={!isActive ? showFeature : null}
          >
            <span className="highlight-banner__button__text">
              Try our highlight differences feature
            </span>
            <span className="highlight-banner__icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.83327 15.2249V12.8916C5.83327 12.2499 6.06174 11.7006 6.51868 11.2437C6.97563 10.7867 7.52493 10.5583 8.1666 10.5583H19.8333C20.4749 10.5583 21.0242 10.7867 21.4812 11.2437C21.9381 11.7006 22.1666 12.2499 22.1666 12.8916V15.2249C22.1666 15.8666 21.9381 16.4159 21.4812 16.8728C21.0242 17.3298 20.4749 17.5583 19.8333 17.5583H8.1666C7.52493 17.5583 6.97563 17.3298 6.51868 16.8728C6.06174 16.4159 5.83327 15.8666 5.83327 15.2249ZM12.8333 4.66659V3.49992C12.8333 3.16936 12.9451 2.89228 13.1687 2.66867C13.3923 2.44506 13.6694 2.33325 13.9999 2.33325C14.3305 2.33325 14.6076 2.44506 14.8312 2.66867C15.0548 2.89228 15.1666 3.16936 15.1666 3.49992V4.66659C15.1666 4.99714 15.0548 5.27422 14.8312 5.49784C14.6076 5.72145 14.3305 5.83325 13.9999 5.83325C13.6694 5.83325 13.3923 5.72145 13.1687 5.49784C12.9451 5.27422 12.8333 4.99714 12.8333 4.66659ZM20.9999 6.64992L21.4666 6.18325C21.6805 5.96936 21.9527 5.86242 22.2833 5.86242C22.6138 5.86242 22.886 5.96936 23.0999 6.18325C23.3138 6.39714 23.4208 6.66936 23.4208 6.99992C23.4208 7.33047 23.3138 7.6027 23.0999 7.81659L22.6333 8.28325C22.4194 8.49714 22.1472 8.60409 21.8166 8.60409C21.486 8.60409 21.2138 8.49714 20.9999 8.28325C20.786 8.06936 20.6791 7.79714 20.6791 7.46659C20.6791 7.13603 20.786 6.86381 20.9999 6.64992ZM12.8333 24.4999V23.3333C12.8333 23.0027 12.9451 22.7256 13.1687 22.502C13.3923 22.2784 13.6694 22.1666 13.9999 22.1666C14.3305 22.1666 14.6076 22.2784 14.8312 22.502C15.0548 22.7256 15.1666 23.0027 15.1666 23.3333V24.4999C15.1666 24.8305 15.0548 25.1076 14.8312 25.3312C14.6076 25.5548 14.3305 25.6666 13.9999 25.6666C13.6694 25.6666 13.3923 25.5548 13.1687 25.3312C12.9451 25.1076 12.8333 24.8305 12.8333 24.4999ZM21.4666 21.9333L20.9999 21.4666C20.786 21.2527 20.6791 20.9805 20.6791 20.6499C20.6791 20.3194 20.786 20.0471 20.9999 19.8333C21.2138 19.6194 21.486 19.5124 21.8166 19.5124C22.1472 19.5124 22.4194 19.6194 22.6333 19.8333L23.0999 20.2999C23.3138 20.5138 23.4208 20.786 23.4208 21.1166C23.4208 21.4471 23.3138 21.7194 23.0999 21.9333C22.886 22.1471 22.6138 22.2541 22.2833 22.2541C21.9527 22.2541 21.6805 22.1471 21.4666 21.9333ZM5.3666 8.28325L4.89993 7.81659C4.68605 7.6027 4.5791 7.33047 4.5791 6.99992C4.5791 6.66936 4.68605 6.39714 4.89993 6.18325C5.11382 5.96936 5.38605 5.86242 5.7166 5.86242C6.04716 5.86242 6.31938 5.96936 6.53327 6.18325L6.99993 6.64992C7.21382 6.86381 7.32077 7.13603 7.32077 7.46659C7.32077 7.79714 7.21382 8.06936 6.99993 8.28325C6.78605 8.49714 6.51382 8.60409 6.18327 8.60409C5.85271 8.60409 5.58049 8.49714 5.3666 8.28325ZM4.89993 20.2999L5.3666 19.8333C5.58049 19.6194 5.85271 19.5124 6.18327 19.5124C6.51382 19.5124 6.78605 19.6194 6.99993 19.8333C7.21382 20.0471 7.32077 20.3194 7.32077 20.6499C7.32077 20.9805 7.21382 21.2527 6.99993 21.4666L6.53327 21.9333C6.31938 22.1471 6.04716 22.2541 5.7166 22.2541C5.38605 22.2541 5.11382 22.1471 4.89993 21.9333C4.68605 21.7194 4.5791 21.4471 4.5791 21.1166C4.5791 20.786 4.68605 20.5138 4.89993 20.2999ZM8.1666 15.2249H19.8333V12.8916H8.1666V15.2249Z"
                  fill="#196ECF"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>

      <div
        className={`highlight-banner__overlay ${
          isActive ? 'is-instruction' : ''
        }`}
        ref={overlayRef}
        style={{
          width: boxWidth,
          height: boxHeight,
          top: boxTop,
          left: boxLeft
        }}
      >
        <div
          className={`highlight-banner__tooltip ${
            isActive ? 'is-instruction' : ''
          }`}
        >
          <div className="highlight-banner__tooltip__content">
            Click to highlight differences, so that you can easily spot
            differences between plans.
          </div>
        </div>
      </div>
    </>
  );
};

export default HighlightBanner;
